module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/HeaderMenu.ejs -->\n<button data-toggle="dropdown"\n        class="btn btn-success btn-bitbucket dropdown-toggle"\n        aria-expanded="false">\n    <i class="fa fa-plus"></i>\n</button>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/HeaderMenu.ejs
// module id = 706
// module chunks = 1